module.exports = __webpack_public_path__ + "static/media/exception.0e873d0b.svg";